import { CMD } from "@/lib/escpos";

const COLS = 42;
const GS = "\x1d";

const latin = (value) => String(value || "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^\x20-\x7e]/g, " ");

const eur = (n) => Number(n || 0).toFixed(2).replace(".", ",") + " EUR";

const rule = (ch = "-") => ch.repeat(COLS) + "\n";

const lr = (left, right) => {
  let l = latin(left);
  const r = latin(right);
  if (l.length + r.length + 1 > COLS) l = l.slice(0, Math.max(0, COLS - r.length - 2));
  return l + " ".repeat(Math.max(1, COLS - l.length - r.length)) + r + "\n";
};

const whenLabel = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return latin(iso);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

const barcode39 = (data) => {
  const code = latin(data).toUpperCase().replace(/[^0-9A-Z \-.$/+%]/g, "");
  if (!code) return "";
  return GS + "H\x02" + GS + "h\x50" + GS + "w\x02" + GS + "k\x04" + code + "\x00" + "\n";
};

export function buildLaundrySlip(tenant, ticket) {
  const items = Array.isArray(ticket?.items) ? ticket.items : [];
  let out = CMD.INIT + CMD.CENTER;
  out += CMD.BOLD_ON + latin(tenant?.business_name || "LAVANDERIA") + "\n" + CMD.BOLD_OFF;
  if (tenant?.address) out += latin(tenant.address) + "\n";
  if (tenant?.phone) out += "Tel. " + latin(tenant.phone) + "\n";
  out += "\n" + CMD.DOUBLE_ON + CMD.BOLD_ON + "BOLLA DI RITIRO\n" + CMD.BOLD_OFF + CMD.DOUBLE_OFF;
  out += CMD.DOUBLE_ON + latin(ticket?.number || "") + "\n" + CMD.DOUBLE_OFF;
  out += barcode39(ticket?.barcode || ticket?.number);
  out += latin(ticket?.barcode || ticket?.number) + "\n";
  out += CMD.LEFT + rule();
  out += lr("Cliente", ticket?.customer_name || "");
  out += lr("Telefono", ticket?.phone || "");
  out += lr("Ritiro", whenLabel(ticket?.pickup_at));
  out += lr("Stato", ticket?.status || "");
  if (ticket?.note) out += "NOTE: " + latin(ticket.note) + "\n";
  out += rule();
  items.forEach((it, i) => {
    const qty = Number(it.qty) || 1;
    const price = Number(it.price) || 0;
    out += lr(`${qty} x ${it.description || it.name || "Capo"}`, eur(qty * price));
    if (it.notes) out += "  " + latin(it.notes) + "\n";
    if (it.barcode) out += `  etich. ${latin(it.barcode)}\n`;
    else out += `  capo ${i + 1}\n`;
  });
  out += rule();
  out += CMD.BOLD_ON + lr("TOTALE", eur(ticket?.total)) + CMD.BOLD_OFF;
  out += lr("Pagato", eur(ticket?.paid_amount));
  out += CMD.BOLD_ON + lr("RESTA", eur(ticket?.balance)) + CMD.BOLD_OFF;
  out += rule() + CMD.CENTER;
  out += "DOCUMENTO NON FISCALE\n";
  out += "Conservare per il ritiro\n";
  out += CMD.CUT;
  return out;
}
